import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CircuitoService } from 'src/app/services';

@Component({
  selector: 'app-circuito-cancela',
  standalone: false,
  templateUrl: './circuito-cancela.component.html',
  styleUrl: './circuito-cancela.component.scss'
})
export class CircuitoCancelaComponent implements OnInit {
  @Input() Circuito: any;

  @Output() alterou = new EventEmitter<any>();

  mensagemSucesso;
  mensagensErro;
  carregando = false;
  cancelado = false;

  constructor(
    private modalService: NgbModal,
    private circuitoService: CircuitoService
  ) { }

  ngOnInit() {
  }

  cancelar() {
    delete this.mensagemSucesso;
    delete this.mensagensErro;
    this.carregando = true;

    this.circuitoService.cancelarCircuito(this.Circuito.Id).subscribe(
      dados => {
        this.carregando = false;
        this.cancelado = true;
        this.Circuito = dados;
        this.alterou.emit(dados);
        console.log(dados);
      },
      erro => {
        this.carregando = false;
        console.log(erro);
        this.mensagensErro = this.errorHandler(erro);
      });
  }

  public errorHandler(erro): string[] {
    let mensagem = [];
    switch (erro.status) {
      case 0: mensagem.push('o servidor não respondeu, tente novamente mais tarde!'); break;
      case 400:
        if (erro.error && erro.error.mensagem)
          mensagem.push(erro.error.mensagem);
        else
          mensagem.push("Houve algum erro na execução, tente novamente!");
        break;
      case 401: mensagem.push('você não tem autorização para executar esta ação!'); break;
      case 404: mensagem.push("Solicitação inválida!"); break;
      case 406: mensagem.push(erro.error.mensagem); break;
      case 500: mensagem.push('Houve um erro interno no servidor! tente novamente, caso o erro persista, entre em contato com o suporte'); break;
      default: mensagem.push(erro.statusText);
    }
    if (erro.error != null && erro.error.mensagens != null) {
      mensagem = [...mensagem, ...erro.error.mensagens];
    }
    return mensagem;
  }

  limparMensagens() {
    delete this.mensagemSucesso;
    delete this.mensagensErro;
  }

  fecharModal() {
    this.modalService.dismissAll();
  }
}
